import { render, staticRenderFns } from "./PurchaseResourceList.vue?vue&type=template&id=7926bc0d"
import script from "./PurchaseResourceList.vue?vue&type=script&lang=js"
export * from "./PurchaseResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports